import { analytics } from '../analytics'

export type EventProps = Record<string, any>

export type StaticAnalytics<TProps extends EventProps> = {
    NAME: string
    toPayload: (props?: TProps) => { event: string; properties?: TProps }
    track: (props?: TProps) => void
    trackWithUtm: (props?: TProps) => void
    trackDebounced: (key: string, props?: TProps, debounceMs?: number) => void
}

export function createAnalyticsStatic<TProps extends EventProps = Record<string, any>>(
    name: string,
): StaticAnalytics<TProps> {
    return {
        NAME: name,
        toPayload(props?: TProps) {
            return { event: name, ...(props ? { properties: props } : {}) }
        },
        track(props?: TProps) {
            analytics.trackWithDefaults(name, props)
        },
        trackWithUtm(props?: TProps) {
            analytics.trackWithUtm(name, props)
        },
        trackDebounced(key: string, props?: TProps, debounceMs?: number) {
            analytics.trackWithDefaultsDebounced(name, key, props ?? {}, debounceMs)
        },
    }
}

export default createAnalyticsStatic
